import React from 'react';
import './Footer.css';
import { FaFacebookF, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="fancy-footer">
      <div className="footer-main">
        <div className="footer-logo">
          <Link to="/">
            <img src="/funfillia_logo.png" alt="Funfillia" title='Funfillia' />
          </Link>
        </div>

        <div className="footer-links">
          
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/TermsAndConditions">Terms & Conditions</Link>
        </div>

        <div className="social-icons">
        <a href="https://www.facebook.com/share/16Kxe1eCVp/" target="_blank" rel="noreferrer"><FaFacebookF /></a>
        <a href="https://www.youtube.com/@FUNFILLIA" target="_blank" rel="noreferrer"><FaYoutube /></a>
         
        </div>
      </div>

      <div className="footer-bottom">
      
        <p>&copy; {new Date().getFullYear()} Funfillia | All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
